<template>
	<div class="banner-split2-about">
		<b-row class="banner">
			<b-col class="col-lg-4 col-sm-12 col-12 left banner-item">
				<div class="inner">
					<img class="icon" src="@/assets/about/info/icon_open_time.svg" alt="">
					<h3 class="title">開館時間</h3>
					<div class="content">
						<b-row>每週六、日 10:00-17:00</b-row>
						<b-row>Saturday & Sunday 10:00-17:00</b-row>
					</div>
				</div>
			</b-col>
			<b-col class="col-lg-8 col-sm-12 col-12 right banner-item">
				<div class="inner">
					<img class="icon" src="@/assets/about/info/icon_tickets.svg" alt="">
					<h3 class="title">票價</h3>

					<div class="content">
						<b-row class="w-100">
							<b-col md="3" cols="12">一般民眾</b-col>
							<b-col md="3" cols="12">入館每人低消100元</b-col>
							<b-col md="6" cols="12">(購買商品、餐食或參加活動皆可計算)</b-col>
						</b-row>

						<hr>
						<b-row class="w-100">
							<b-col md="3" cols="12">優惠票</b-col>
							<b-col md="6" cols="12">
                <ul>
                  <li>50元/人</li>
									<li>3歲以下免低消</li>
                </ul>
              </b-col>
							<!-- <b-col md="6" cols="12">
								<ul>
									<li>65歲以上長者</li>
									<li>身高90公分以下或三歲以下兒童</li>
								</ul>
							</b-col> -->
						</b-row>
					</div>
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import Slider from '@/components/slider'
export default {
  name: "bannerSplit2About",
  data() {
    return {
    };
  },
  methods: {

  },
  props: {
    ch: String,
    en: String
  },
  components: {
    Slider
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  @import '../../stylesheet/base.sass'
  @import '../../stylesheet/layout.sass'

  .banner-split2-about
    overflow: hidden
    white-space: normal
    .banner
      .banner-item
        min-height: 480px
        @media screen and(max-width: 900px)
          min-height: 0px
        .inner
          +flexLayout('start2', 'col')
          +size(100%, 100%)
          padding-top: 64px
          padding-bottom: 40px
          .icon
            +size(32px, 32px)
          .title
            font-size: $font-size-1
            font-weight: 500
            margin: 10px 0 40px 0
            text-align: center
            line-height: 1.5
          .content
            font-size: $font-size-3
            line-height: 2
            .sleep
              margin-top: 64px
              white-space: normal

      .left
        padding-right: 12px
        .content
          +flexLayout('center', 'col')
        .inner
          background-color: #edfbff
          white-space: nowrap

      .right
        background-color: #fafafa
        padding: 0 35px
        .inner
          .content
            width: 100%
            li
              margin-bottom: 10px
        hr
          border-color: #01b6e2


</style>



// WEBPACK FOOTER //
// src/components/banner/banner_split2_about_info.vue